import React,{useEffect} from 'react';
import { makeStyles, withStyles,useTheme } from '@material-ui/core/styles';
import { withRouter,useHistory,NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat,amountFormatOnly, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../Dialog/Dialog';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
  } from 'mui-rff';
  import {
    Typography,
    Paper,
    Link,
    Grid,
    Button,
    Card,
    Dialog,
    CardActions,
    CardContent,
    CssBaseline,
    MenuItem,
    InputAdornment,
    InputLabel,
    FormControl,
    CardHeader,
    TextField as TextInput,
    Checkbox,
    Box,
    Tabs,
    Tab,
    MobileStepper
  } from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
    getTripDetailsV3,
    updateTripStatus
} from "../../../store/actions/tripActionCreator";
import {sendError, sendSucces} from "../../../utils/utils"
import inputStyles from '../css/inputs'
import {
    TRIP_STATUS,
    TRIP_DISPLAY_STATUS,
    TRIP_ACTIONS,
    TRIP_STATUS_DIALOG_TITLES,
    TRIP_STATUS_DIALOG_LABELS,
    PAYMENT_CHIPS,
    TRIP_ACTIONS_FORM_LABELS
} from "../../../store/constants";
import S3Uploader from '../s3Uploader/s3Uploader';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:'center',
    height: 50,
    //paddingLeft: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height: 255,
    display: 'block',
    maxWidth: 400,
    overflow: 'hidden',
    width: '100%',
  },
}));
const ImageViewDialog = (props) => {
    const classes = useStyles();
    const inputClasses = inputStyles();
    let submit
    const { 
        user, 
        onConfirm, 
        open, 
        onClose, 
        onSave,
        action,
        defaultPerson,
        location,
        active,
        header,
        uploadText,
        ...other 
    } = props;
    let path = location && location.pathname ? location.pathname.split("/") : [];
  
    const [dialogopen, setDialogOpen] = React.useState(open);
    const [enableClick, setEnableClick] = React.useState(false);
    const handleFormSave = (e) => {
    }
    const handleClose = (status) => {
        onClose(false);
    };
    const handleConfirm= (status) => {
      onConfirm(images);
    };
    const getFormFields = (values)=>{
        let commonFields = [];
        return commonFields;
    }
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(active?active:0);
    const [images, setImages] = React.useState([]);
    const maxSteps = images.length;
    useEffect(() => {
      setEnableClick(!enableClick);
    }, [dialogopen]);
    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
      setActiveStep(step);
    };
    const handleUpload = (file) => {
      var newImages = [...images];
      newImages.push(file);
      setImages(newImages);
    };
    const handleCTADelete = (index) => {
      var newImages = [...images];
      newImages.splice(index, 1);
      setImages(newImages);
    }
    return (
        <div>
            <Dialog 
                fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} 
                disableEscapeKeyDown={true} 
                disableBackdropClick={true} 
                aria-labelledby={"Image-Uploader"}
                open={dialogopen}
            >
                <DialogTitle id={"Image-uploader"} onClose={handleClose}>
                {header?header:'View Images'}
                </DialogTitle>
                <TripActionDialogContent dividers>
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                  >
                    {images && images.length>0 &&<Grid item>
                      <div className="S3Uploader-image-margin">
                        {images && images.map((img, index) => ( 
                          <div className="S3Uploader-image-div">                  
                              <img className="S3Uploader-imagesrc" src={img} alt="fileUpload" />
                              <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => {handleCTADelete(index)}}></img>
                          </div>  
                        ))}
                      </div>
                    </Grid>}
                    <Grid item>
                      <S3Uploader toggle={true} directoryName={"dweb-images/ImageUploadDialog"} handleFile={handleUpload} enableClick={enableClick} text={uploadText?uploadText:null} />
                    </Grid>
                  </Grid>
                </TripActionDialogContent>
                <DialogActions>
                    <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
                        Close
                    </Button>
                      <Button variant="contained" className='modal-save-cta' onClick={handleConfirm}>
                          Confirm
                      </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
const ImageViewDialogWithRouter = withRouter(ImageViewDialog);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageViewDialogWithRouter);